import { FC, useEffect, useState } from 'react';
import { Button, Form, notification } from 'antd';
import { CheckCircleTwoTone } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import cn from 'classnames';
import {
  CampaignRequest,
  campaignSlice,
  campaignsStatus,
  createCampaign,
  getCampaignCopy,
  selectCampaignRequest,
} from '../../store/reducers/CampaignSlice';
import {
  getSipAccounts,
  selectSipAccounts,
} from '../../store/reducers/SIPAccountSlice';
import { useAppDispatch, useAppSelector } from '../../store/store';
import Blocks from '../Blocks/Blocks';
import CampaignSettings from './CampaignSettings/CampaignSettings';
import CreateCampaignMenu from './CreateCampaignMenu/CreateCampaignMenu';
import PhoneList from './PhoneList/PhoneList';
import styles from './style.module.css';

const CreateCampaign: FC = () => {
  const [selectedKey, setSelectedKey] = useState('main');
  const [showCampaignSettings, setShowCampaignSettings] = useState(true);
  const [showPhoneList, setShowPhoneList] = useState(false);

  const { state } = useLocation();

  const campaignRequest = useAppSelector(selectCampaignRequest);

  const status = useAppSelector(campaignsStatus);

  const sipAccounts = useAppSelector(selectSipAccounts);

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { updateRequestStatus } = campaignSlice.actions;

  const [api, contextHolder] = notification.useNotification();

  const [form] = Form.useForm();

  useEffect(() => {
    if (state) {
      dispatch(getCampaignCopy(state));
    } else {
      dispatch(getSipAccounts());
    }
  }, [state]);

  useEffect(() => {
    if (form && campaignRequest) {
      form.setFieldsValue(campaignRequest);
    }
  }, [campaignRequest]);

  useEffect(() => {
    if (sipAccounts.length > 0) {
      let deffaultAccountId = sipAccounts.find((x) => x.default)?.id;

      if (!deffaultAccountId) {
        deffaultAccountId = sipAccounts[0].id;
      }

      if (form) {
        form.setFieldsValue({
          dialAccountId: deffaultAccountId,
          operatorAccountId: deffaultAccountId,
        });
      }
    }
  }, [sipAccounts]);

  useEffect(() => {
    if (status.requestSuccess !== null) {
      successNotification();

      setTimeout(() => navigate('/campaigns'), 2000);
    }
    if (status.requestError !== null) {
      errorNotification();
    }
    dispatch(updateRequestStatus());
  }, [status]);

  const successNotification = () => {
    api.info({
      message: status.requestSuccess,
      placement: 'bottomRight',
      icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    });
  };

  const errorNotification = () => {
    api.info({
      message: status.requestError,
      placement: 'bottomRight',
      icon: <CheckCircleTwoTone twoToneColor="#eb0000" />,
    });
  };

  const updateData = (key: string) => {
    switch (key) {
      case 'main':
        setSelectedKey('main');
        setShowCampaignSettings(true);
        setShowPhoneList(false);
        break;
      case 'phones':
        setSelectedKey('phones');
        setShowPhoneList(true);
        setShowCampaignSettings(false);
        break;
    }
  };

  const handleSubmit = (campaignRequest: CampaignRequest) => {
    campaignRequest.startCallDateTime =
      campaignRequest.callDateTime[0].format('DD.MM.YYYY');

    campaignRequest.endCallDateTime =
      campaignRequest.callDateTime[1].format('DD.MM.YYYY');

    dispatch(createCampaign(campaignRequest));
  };

  return (
    <>
      {contextHolder}
      <Blocks
        topBlock={
          <CreateCampaignMenu
            selectedKey={selectedKey}
            updateData={updateData}
          />
        }
        mainBlock={
          <Form
            form={form}
            colon={false}
            labelWrap={true}
            labelAlign="left"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 14 }}
            className={cn(styles.blockForm, styles.form)}
            onFinish={handleSubmit}
            onFinishFailed={(errorInfo) => {
              console.log(errorInfo);
              if (
                !errorInfo.values.clientPhones.find(
                  (x) => x.fullName && x.phone,
                )
              ) {
                updateData('phones');
              } else {
                updateData('main');
              }
            }}
          >
            <CampaignSettings
              showCampaignSettings={showCampaignSettings}
              key="campaignSettings"
            />
            <PhoneList
              updateData={(clientPhones) =>
                form.setFieldValue('clientPhones', clientPhones)
              }
              showPhoneList={showPhoneList}
              key="phoneList"
            />
            <Button
              size="large"
              type="primary"
              className={styles.blockSaveButton}
              htmlType="submit"
            >
              Создать
            </Button>
          </Form>
        }
      />
    </>
  );
};

export default CreateCampaign;
